import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import pageService from './services/home/home.service';

function Navbar() {
  const [isInitialized, setIsInitialized] = useState<boolean>(false);
  const [version, setVersion] = useState<string | undefined>();

  const isAuthenticated = () => {
    const tokenCheck = localStorage.getItem('token');
    return tokenCheck ? true : false;
  };

  useEffect(() => {
    if (!isInitialized) {
      setIsInitialized(true);
      (async () => {
        await pageService.getVersion()
          .then(response => { 
            setVersion(response.data);
          });
      })();
    }
  }, [isInitialized]);

  return (<nav>
    {
      isAuthenticated() &&
      <>
        <ul>
          <li>
            <Link to="/summary">Summary</Link>
          </li>
          <li>
            <Link to="/archive">Archive</Link>
          </li>
          <li>
            <Link to="/flows">Flows Manager</Link>
          </li>
          <li>
            <Link to="/watchdog">Watch Dog</Link>
          </li>
          <li>
            <Link to="/">Logout</Link>
          </li>
        </ul>
        <p>v: {version}</p>
      </>
    }
  </nav>);
}

export default Navbar;